import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks";
import { productImagePlaceholder, formatCurrency, getColorSwatches, getSrcset, checkProdPriceVaries, quickViewToggle, getImages, getColorFromImage, getColorSwatchesViaCustomField, getRelatedProduct, categoriesToExcludeSwatches } from "../helpers"
import { uniqueColorSwatches } from "../config"
import Swatches from './Swatches'
import { useConfig } from "@nosto/preact";


export default function Product({ product, isExchangeCollection }) {
    // const [ colorSwatches, setColorSwatches ] = useState(null);
    const [ customFieldColorSwatches, setCustomFieldColorSwatches ] = useState(null);
    const [ priceRange, setPriceRange ] = useState(null);
    const [ currentVariant, setCurrentVariant ] = useState(null);
    const [ variantImages, setVariantImages ] = useState(null);

    const handle = product.url.split('/products/')[1];
const usaBadge = !!product.tags1?.find(tag => tag === "USA");
const recurateBadge = !!product.tags1?.find(tag => tag === 'used');
const badge = product.tags1?.find(tag => tag.includes("Badge_"))?.replace("Badge_", "");
const isExchangeBadge = product?.skus?.some(sku => sku.customFields?.find(attr => attr.key === "recurate-source")?.value === "individual_seller")

    // new logic for swatches FEA-10938
    const customGroup = product?.customFields?.find(field => field?.key === "custom-product_group")?.value;

    // console.log("RELATED PRODUCT", getRelatedProduct(product.customFields));
    
    useEffect(() => {
        // setColorSwatches(getColorSwatches(product?.skus, product.imageUrl));
        setPriceRange(checkProdPriceVaries(product));
        // new logic for swatches FEA-10938
        const fetchColorSwatches = async () => {
            try {
                const swatches = await getColorSwatchesViaCustomField(customGroup, product?.productId);
                setCustomFieldColorSwatches(swatches);
            } catch (error) {
                console.error("Error fetching color swatches:", error);
            }
        };
        fetchColorSwatches();
    }, [])


    // console.log(customFieldColorSwatches);

    // useEffect(() => {
    //     if(!isExchangeCollection && colorSwatches?.length > 0) {
    //         const currentColor = getColorFromImage(product.imageUrl).toLowerCase().replaceAll('\/', '-').replaceAll(' ', '-')
            
    //         const currentVariant = colorSwatches.find(sku => {
    //             let skuColor = sku.customFields?.find(field => field.key === 'color')?.value?.toLowerCase()?.replaceAll('\/', '-')?.replaceAll(' ', '-')
    //             return skuColor === currentColor
    //         }) || colorSwatches[0];

            
    //         setCurrentVariant(currentVariant);
    //         const currentImages = getImages(currentVariant, product?.alternateImageUrls, product.imageUrl);
    //         setVariantImages(currentImages);
    //     }
    // }, [ isExchangeCollection, colorSwatches, product ])

    const handleVariantChange = (e) => {
        const clickedVariantId = e.target.value;
        if(!currentVariant || currentVariant?.id !== clickedVariantId) {
            const variant = product.skus.find(sku => Number(sku.id) === Number(clickedVariantId))
            setCurrentVariant(variant);
            const currentImages = getImages(variant, product?.alternateImageUrls);
            setVariantImages(currentImages)
        }
    }

    // console.log('variantImages', variantImages);

    // logic for hiding swatches
    const config = useConfig();
    const categoryIdValue = config.categoryId();
    const isHiddenSwatches = categoriesToExcludeSwatches.includes(categoryIdValue) || (product.brand === "Trove" || product.brand === "Recurate");
    // -----

    return (
        <SerpElement
            as="article"
            hit={product}
            class={`ns-product ${isHiddenSwatches ? "ns-hide-swatches" : ""}`}
        >
            <div class="ns-prod-img-wrap">
                <a href={`${currentVariant ? `${product.url}?variant=${currentVariant.id}` : product.url}`} class="ns-prod-image-link">
                    {(usaBadge || (recurateBadge && isExchangeBadge)) && (
                        <div class="ns-img-badge-container">
                            <img
                                class="ns-prod-img-badge"
                                src={(usaBadge)
                                    ?   "https://www.thefryecompany.com/cdn/shop/files/frye_made-in-the-usa-badge_150x.png?v=1680554825"
                                    :   "https://cdn.shopify.com/s/files/1/0140/3371/5254/files/frye-exchange-logo.png?v=1680554831"
                                }
                                width={56}
                                height={(usaBadge) ? 43 : 56}
                                alt={(usaBadge) ? "The Frye Made in USA logo" : "The Frye Exchange logo"}
                            />
                        </div>
                    )}
                    <img
                        class="ns-main-img"
                        srcset={(!isExchangeCollection && variantImages?.main)
                                ?   getSrcset(variantImages?.main)
                                :   (product.imageUrl)
                                    ?   getSrcset(product.imageUrl)
                                    :   ""
                        }
                        src={(!isExchangeCollection && variantImages?.main)
                            ?   variantImages?.main.replace('.jpg', '_840x.jpg').replace('.png', '_840x.png')
                            :   (product.imageUrl)
                                ?   product.imageUrl.replace('.jpg', '_840x.jpg').replace('.png', '_840x.png')
                                :   productImagePlaceholder
                        }
                        alt={product.name}
                        width="400"
                        height="600"
                    />
                    {(!isExchangeCollection && variantImages?.alt || !isExchangeCollection && product.alternateImageUrls?.length > 0) && (
                        <img
                            class="ns-hover-img"
                            srcset={(variantImages?.alt && variantImages?.alt !== '')
                                    ?   getSrcset(variantImages.alt)
                                    :   (product.alternateImageUrls[0] && product.alternateImageUrls[0] !== '')
                                        ?   getSrcset(product.alternateImageUrls[0])
                                        :   ""
                            }
                            src={(variantImages?.alt && variantImages?.alt !== '')
                                ?   variantImages.alt.replace('.jpg', '_840x.jpg').replace('.png', '_840x.png')
                                :   (product.alternateImageUrls[0] && product.alternateImageUrls[0] !== '')
                                    ?   product.alternateImageUrls[0].replace('.jpg', '_840x.jpg').replace('.png', '_840x.png')
                                    :   ''
                            }
                            alt={product.name}
                            width="400"
                            height="600"
                        />
                    )}
                </a>

                <button
                    class="ns-quickview-btn button"
                    type="button" 
                    role="button" 
                    aria-haspopup="dialog" 
                    aria-controls="nosto-quickview" 
                    tabIndex="0"
                    onClick={() => {
                        quickViewToggle(
                            handle,
                            product.productId,
                            getRelatedProduct(product.customFields), 
                            currentVariant?.customFields?.find(f => f.key === 'color').value,
                            null
                        )
                    }}
                >
                    Quick Shop
                </button>
            </div>
            <div class="ns-badges-container">
                {badge &&
                    <span class="ns-prod-badge">{badge}</span>
                }
            </div>
            <div class="ns-prod-name">
                <a
                    href={`${currentVariant ? `${product.url}?variant=${currentVariant.id}` : product.url}`} 
                    class="ns-prod-name-link"
                >
                    {product.name}
                </a>
            </div>
            <div class="ns-price-container">
                {priceRange && priceRange.varies ? (
                    <>
                        <span class="visually-hidden sr-only">Price range:</span>
                        <span class="price final-price">{`${formatCurrency(priceRange.min)} - ${formatCurrency(priceRange.max)}`}</span>
                    </>
                ) : (product.listPrice > product.price) ? (
                    <>
                        <span class="visually-hidden sr-only">Sale price:</span>
                        <span class="price sale-price">{formatCurrency(product.price)}</span>
                        <span class="visually-hidden sr-only">Original price:</span>
                        <span class="price original-price">{formatCurrency(product.listPrice)}</span>
                    </>
                ) : (
                    <>
                        <span class="visually-hidden sr-only">Final price:</span>
                        <span class="price final-price">{formatCurrency(product.price)}</span>
                    </>
                )}
            </div>

            <Swatches relatedProduct={getRelatedProduct(product.customFields)} currentProduct={product}/>


            {/* <div class="ns-prod-swatches"> */}
                
                {/* {(colorSwatches?.length > 0) && (
                    <>
                        {colorSwatches.slice(0, 4).map(sku => {
                            let colorName = sku.customFields?.find(f => f.key === 'color')?.value?.replaceAll(' ', '-').replaceAll('\/', '-').toLowerCase();
                            if (uniqueColorSwatches[colorName]) {
                                colorName = uniqueColorSwatches[colorName];
                            } else if (uniqueColorSwatches[colorName] === false) {
                                return;
                            }
                            return (
                                <div class="ns-color-swatch">
                                    <input 
                                        class="ns-color-swatch-input"
                                        id={`ns-${colorName}-${sku.id}`} 
                                        type="radio" 
                                        name={`${product.productId}-color`} 
                                        value={sku.id} 
                                        checked={(currentVariant && currentVariant.id === sku.id)}
                                        onChange={handleVariantChange}
                                    />
                                    <label
                                        class="ns-color-swatch-label"
                                        for={`ns-${colorName}-${sku.id}`} 
                                    >
                                        <img
                                            class="ns-color-swatch-img"
                                            src={`https://www.thefryecompany.com/cdn/shop/files/product_color_${colorName}.png?crop=center&height=16&width=16`}
                                            alt={`${sku.customFields?.find(f => f.key === 'color')?.value}`}
                                            width={16}
                                            height={16}
                                        />
                                    </label>
                                </div>
                            )
                        })}
                        {(colorSwatches?.length > 4) &&
                            <a 
                                href={`${currentVariant ? `${product.url}?variant=${currentVariant.id}` : product.url}`}
                                class="ns-swatch-count"
                            >
                                +{(colorSwatches.length - 4)}
                            </a>
                        }
                    </>
                )} */}
                {/* {(customFieldColorSwatches?.length > 0) && (
                    <>
                        {customFieldColorSwatches.slice(0, 4).map((fetchedProduct, index) => {
                            let colorName = getColorFromImage(fetchedProduct?.imageUrl);
                            colorName = colorName.toLowerCase();
                            let formattedName = fetchedProduct?.name?.replace(" &","").replace("/","").split(" ").join("-").toLowerCase();
                            let srcForSwatchImg;
                            // if(colorName === "dark-brown"){
                            //     colorName = "black";
                            // }
                            // console.log(colorName, product?.name);
                            if (uniqueColorSwatches[colorName]) {
                                colorName = uniqueColorSwatches[colorName];
                            } else if (uniqueColorSwatches[colorName] === false) {
                                return;
                            }
                            return (
                                <div class="ns-color-swatch">
                                    <a
                                        class={`ns-color-swatch-label ${index === 0 ? 'ns-color-swatch-selected' : ''}`}
                                        for={`ns-${colorName}-${fetchedProduct?.productId}`}
                                        href={fetchedProduct?.url} 
                                    >
                                        <img
                                            class="ns-color-swatch-img"
                                            src={`https://www.thefryecompany.com/cdn/shop/files/productcolor__${formattedName}-${colorName}.png?crop=center&height=16&width=16`}
                                            alt={`${colorName}`}
                                            width={16}
                                            height={16}
                                        />
                                    </a>
                                </div>
                            )
                        })}
                        {(customFieldColorSwatches?.length > 4) &&
                            <a 
                                href={`${product.url}`}
                                class="ns-swatch-count"
                            >
                                +{(customFieldColorSwatches.length - 4)}
                            </a>
                        }
                    </>
                )} */}
            {/* </div> */}

        </SerpElement>
    )
}
